import Recipes from 'containers/computers/recipes/Recipes';
import enhance from 'containers/computers/recipes/Recipes.enhancer';

export default enhance(Recipes);
